import React, {Component} from 'react';
import * as R from 'ramda';
import t from 'tcomb-form';
import classNames from 'classnames';

const checkImages = {
    default: require('images/icons/grey_check_outline.png'),
    selected: require('images/icons/blue_check.png')
};

export default class FormRadio extends Component {
    static displayName = 'FormRadio';

    constructor(props) {
        super(props);
        this.state = {value: props.value};
    }

    isValueNully() {
        return this.state.value === null;
    }

    handleClick = value => {
        const shouldSetValueToNull =
            value === this.state.value && !this.props.options.disableDeselectAll;
        this.setState({
            value: shouldSetValueToNull ? null : value
        });
        this.props.onChange(value, this.props.ctx.path);
    };

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.state.value;
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    render() {
        const {value, hasError} = this.state;
        const label = this.props.options.label || this.props.ctx.label;
        const {name} = this.props.ctx;
        const {optionsMap, exclude} = this.props.options;
        const excludedKeys = exclude || [];
        const enumPairs = optionsMap ? R.toPairs(optionsMap) : R.toPairs(this.props.type.meta.map);
        const iconMap = this.props.options.iconMap;
        const labelMap = this.props.options.labelMap;

        const radioButtons = enumPairs.map(([v, label]) => {
            if (R.indexOf(v, excludedKeys) !== -1) {
                return '';
            }

            const isSelected = v === value;
            const iconStyle = {
                backgroundImage: `url(${isSelected ? checkImages.selected : checkImages.default})`
            };

            if (iconMap) {
                let icon = iconMap[v];
                if (R.is(Array, icon)) {
                    icon = isSelected ? icon[1] : icon[0];
                }
                iconStyle.backgroundImage = `url(${icon})`;
            }

            if (labelMap) {
                label = labelMap[v];
                if (R.is(Array, label)) {
                    label = isSelected ? label[1] : label[0];
                }
            }

            return (
                <div
                    id={(isSelected && 'selected-publisher-type') || 'not-selected-publisher-type'}
                    className={classNames('radio-btn', label, isSelected && 'active')}
                    key={v}
                    onClick={R.partial(this.handleClick, [v])}
                >
                    <div className="radio-btn-check" style={iconStyle} />
                    <div>{label}</div>
                </div>
            );
        });

        return (
            <div
                id={name}
                name={name}
                className={classNames(
                    'radio-group-horizontal',
                    'form-group',
                    hasError && 'has-error'
                )}
            >
                <label className="control-label">{label}</label>

                <div className="radio-btns">{radioButtons}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_radio.js